//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------

gameController = {};

gameController.overlayDownTweens = [];
gameController.backingDownTweens = [];
gameController.currentSlidingCollects = [];

gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.anticipating = false;
gameController.cloversAdded = false;
gameController.useBuyBonusThresholds = false;
gameController.bigWinFinished = false;

gameController.bonusSymbolsLanded = 0;
gameController.logoSymbolAnticipationReel = -1;
gameController.minBonusForFeature = 3; //should be data driven

gameController.canSlamStop = false;
gameController.slamStopped = false;
gameController.preFSReelPrize = 0;
gameController.isPrePaid = false;
gameController.inBuyABonus = false;
gameController.inBuyABonusFirstSpin = false;
gameController.justHadFreeSpins = false;
gameController.shouldAnticipate = false;

gameController.timerFadeSpinsLoopIntoIdle = undefined;
gameController.spinTuneId = undefined;
gameController.idleTuneId = undefined;

gameController.reelspinId = 0;

gameController.symbolLandAnimator = undefined;
gameController.inRespin = false;

gameController.platformPaused = false;
gameController.cyclingWinlines = false;
gameController.isTopHitReelNudged = undefined;

gameController.canSkipWin = false;
gameController.coinsCurrentlySkippable = false;
gameController.skippingWayWins = false;
gameController.inRecovery = false;
gameController.inBuyABonusRecovery = false;
gameController.postGambleFsCount = 0;

gameController.mainReelAnticipationSoundStarted = false;
gameController.nudgeReelAnticipationSoundStarted = false;
gameController.anticipationEmitter = undefined;

gameController.persistentValues = undefined;
gameController.currentPersistentState = undefined;
gameController.respinsTriggerCount = undefined;
gameController.goldenBetRespinsTriggerCount = undefined;

gameController.lineWinsOnly = 0;
gameController.themeResetCount = 0;

gameController.license = undefined;

gameController.stopWindow = undefined;

gameController.bonusBetStake = 0;
gameController.coinID = 18;
gameController.bonusID = 12;
gameController.cloverID = [15, 16, 17];
gameController.potID = 19;
gameController.collectID = 14;
gameController.totalWin = undefined;
gameController.winlinesWins = [];
gameController.symbolMap = [];
gameController.winWaysValue = 0;
gameController.desktopWinWaysCounter = undefined;
gameController.mobileWinWaysCounter = undefined;
gameController.coinCollectTarget = 30;
gameController.coinCollectCurrent = 0;
gameController.cloverSpinsCurrent = 0;
gameController.cloverEmitter = undefined;
gameController.coins = undefined;
gameController.cashCoinsAnimationsComplete = false;
gameController.prizePotAnimationsComplete = false;
gameController.cashCoinAmountText = undefined;
gameController.cashCoinAmountBacking = undefined;
gameController.coinAwards = undefined;
gameController.coinAwardsAfterGoldenSpins = undefined;
gameController.coinAwardsBeforeGoldenSpins = undefined;
gameController.cloverRespinsComplete = false;
gameController.defaultCloverCount = 3;
gameController.defaultCoinCount = 5;
gameController.lockedCoins = [];
gameController.goldenSpins = undefined;
gameController.goldenSpinTexts = [];
gameController.goldenSpinsMeterAtEnd = undefined;
gameController.winAmountSoFar = undefined;
gameController.totalWinnings = 0;
gameController.amountWonInBaseGame = 0;
gameController.hasCoinWin = false;
gameController.winningLines = undefined;
gameController.winGroups = [];
gameController.winGroupSymbolIds = [];
gameController.symbolsToAnimate = [];

gameController.arrCount = 0;
gameController.currentWinnings = 0;
gameController.previousWinnings = 0;
gameController.coinWinnings = 0;

gameController.slidingOverlays = [];
gameController.slidingOverlayBackings = [];
gameController.previousResult = [];
gameController.uniqueId = 0;
gameController.cyclingWinsIndex = 0;
gameController.overlayDownTweens = [];
gameController.backingDownTweens = [];
gameController.numberOfLandAnimationsPlaying = 0;
gameController.waitingForNextWinAnimation = false;
gameController.freeSpinsTransitionOut = false;

gameController.UIRandomSeed = undefined;
gameController.UINumGenerator = undefined;

// MARK TRUE ONCE INITIALISED
gameController.gameInitialised = false;

gameController.fadeSound = function (soundsToFade, fadeTo, time, fadeIn) {
  timerManager.addTimer(
    time,
    function (progress) {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          let fade = fadeTo * (1 - progress);
          if (fadeIn) {
            fade = fadeTo * progress;
          }
          soundManager.setVolume(fade, sound);
        }
      });
    },
    function () {
      soundsToFade.forEach(function (sound) {
        if (sound) {
          soundManager.setVolume(fadeTo, sound);
        }
      });
    }
  );
};

gameController.delay = (ms) => new Promise((res) => setTimeout(res, ms));

gameController.onLayoutComplete = function (task) {
  gameController.buyBonusCostFreeSpinsHigh = task.data.buyBonusCostFreeSpinsHigh;
  gameController.buyBonusCostFreeSpinsMed = task.data.buyBonusCostFreeSpinsMed;
  gameController.buyBonusCostFreeSpinsLow = task.data.buyBonusCostFreeSpinsLow;

  // THAI TEXT ISSUE FIX (IOS MUTATING TEXT WITH WEIRD CHARACTERS, CAUSING OVERLAP)
  const buyBonusTitle = resourceManager.get("buyABonusContainer:buyBonusPopup:buyBonusBacking:buyABonusTitle");
  const goldenBetPopupTitle = resourceManager.get(
    "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage:goldenBetText"
  );
  buyBonusTitle.setMaxWidth(buyBonusTitle.maxWidth);
  goldenBetPopupTitle.setMaxWidth(goldenBetPopupTitle.maxWidth);
};

gameController.initialise = function () {
  gameController.bigWin = resourceManager.get("bigWin");
  gameController.bigWin.init();
  SmallWinController.initialise();
  BackgroundAnimsView.initialise();
  symbolLandAnimator.initialise();

  spineSymbolAnimator.initialise();
  symbolAnimator.initialise();

  resourceManager.get("postReels:reel4Anticipation").visible = false;
  // resourceManager.getContainer('soundTrack').visible = true;

  gameController.persistentValues = gameData.slotConfig.persistentValues;
  gameController.respinsTriggerCount = gameData.slotConfig.respinsTriggerCount;
  gameController.goldenBetRespinsTriggerCount = gameData.slotConfig.goldenBetRespinsTriggerCount;

  gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());

  gameController.desktopWinWaysCounter = resourceManager.get("winWaysContainer:winWaysValue");
  //gameController.mobileWinWaysCounter = resourceManager.get("winWaysContainer:winWaysValueMobile");

  resourceManager.get("buttonContainer:buttonBar:autoplayButton:glow").visible = false;

  const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");

  gameController.cashCoinAmountText = resourceManager.get(
    "postReels:cashCoinAmountContainer:cashCoinAmountBacking:cashCoinAmountText"
  );
  gameController.cashCoinAmountContainer = resourceManager.get("postReels:cashCoinAmountContainer");
  gameController.cashCoinAmountBacking = resourceManager.get("postReels:cashCoinAmountContainer:cashCoinAmountBacking");
  CoinsView.initialise();
  CoinCollectionController.initialise();
  PrizePots.initialise();
  GoldenSpins.initialise();
  CloverRespins.initialise();
  CloverRespins.completed = false;
  volumeButton.canShowBase = volumeButton.canShow;
  const canEnableSound = settingsMenu.buttons.btnSound.visible;
  volumeButton.canShow = function () {
    const soundButton = resourceManager.get("systemSettings:systemSettingsBox:settingSound");

    // soundButton.alpha = canEnableSound ? 1 : 0.3;
    soundButton.setActive(canEnableSound);
    return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
  };
  gameController.cloverEmitter = particleManager.createEmitter(
    "cashcoinParticle",
    "particlesContainerFront",
    0,
    0,
    false
  );
  gameController.cloverEmitter.particleEmitter.emit = false;
  gameController.cloverEmitter.visible = false;

  gameController.setupSlotAnimVisuals();

  gameController.slotMachine = resourceManager.getController("SlotMachine");

  const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4"];
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);

    gameController.playLandSounds(reel);

    gameController.stoppedReels[reel] = true;
    console.log("reel landed: " + reel);
    gameController.onSpinHit(reel);
  });

  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    timerManager.delayAsync(gameController.slamStopped ? 10 : 0, undefined, () => {
      gameController.onSpinLand(reel);
    });
  });

  for (let i = 0; i < 5; ++i) {
    let rv = resourceManager.get("slotContainer:reelContainer:reel" + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.slotMachine.selectReelMode("default");

  gameController.winlineAnimator = resourceManager.getSharedPlugin("WinlineAnimatorEx");

  const slamStopButton = resourceManager.get("buttonContainer:buttonBar:slamStopButton");
  slamStopButton.canEnableBase = slamStopButton.canEnable;
  slamStopButton.canEnable = function () {
    return this.canEnableBase() && gameController._receivedResponse;
  };

  gameController.symbolLandAnimator = resourceManager.get("slotContainer:BonusLandAnimator");

  gameController.originalStopDistances = gameController.slotMachine._currentMode.stopDistances;

  gameController.symbolAnimator = resourceManager.get("slotContainer:SymbolAnimator");

  // COIN COLLECT METER ASSETS
  gameController.coinCollectFillContainer = resourceManager.get(
    "postReels:CoinCounterContainer:coinCollectFillContainer"
  );
  // gameController.coinCollectGreenFill = resourceManager.get("postReels:CoinCounterContainer:coinCollectFill");
  // gameController.coinCollectGoldFill = resourceManager.get("postReels:CoinCounterContainer:coinCollectFillGold");
  gameController.coinCollectGreenFillMask = resourceManager.get("postReels:CoinCounterContainer:coinCollectFillMask");

  gameController.createCollectFillAssets();

  gameController.animateBackgroundAssets();

  gameController.onOrientationChange();

  musicManager.onGameLoaded();

  gameController.gameInitialised = true;
};

gameController.createCollectFillAssets = function () {
  gameController.coinCollectFillContainer = resourceManager.get(
    "postReels:CoinCounterContainer:coinCollectFillContainer"
  );
  gameController.coinCollectFillCompletionContainer = resourceManager.get(
    "postReels:CoinCounterContainer:coinCollectFillCompletionContainer"
  );

  gameController.coinCollectGreenFill = resourceManager.createObject(
    "movie",
    "coinCollectGreenFill",
    gameController.coinCollectFillContainer,
    {
      definition: "greenPersistenceBar",
    }
  );
  gameController.coinCollectGoldFill = resourceManager.createObject(
    "movie",
    "coinCollectGoldFill",
    gameController.coinCollectFillContainer,
    {
      definition: "goldPersistenceBar",
    }
  );

  gameController.coinCollectGreenFillCompletion = resourceManager.createObject(
    "movie",
    "coinCollectGreenFillCompletion",
    gameController.coinCollectFillCompletionContainer,
    {
      definition: "greenPersistenceBarCompletion",
    }
  );
  gameController.coinCollectGreenFillCompletion.visible = false;
  gameController.coinCollectGreenFillCompletion.gotoAndStop(0);
  gameController.coinCollectGreenFillCompletion.loop = false;

  gameController.coinCollectGoldFillCompletion = resourceManager.createObject(
    "movie",
    "coinCollectGoldFillCompletion",
    gameController.coinCollectFillCompletionContainer,
    {
      definition: "goldPersistenceBarCompletion",
    }
  );
  gameController.coinCollectGoldFillCompletion.visible = false;
  gameController.coinCollectGoldFillCompletion.gotoAndStop(0);
  gameController.coinCollectGoldFillCompletion.loop = false;
};

gameController.updateCounters = function (orientationChange = false) {
  let cloverCountText = resourceManager.get("postReels:rapidRespinsContainer:rapidRespinsMeterCount");

  const coinCollectGreenFill = gameController.coinCollectGreenFill;
  const coinCollectGreenFillMask = gameController.coinCollectGreenFillMask;
  const coinCollectGoldFill = gameController.coinCollectGoldFill;

  let coinCounterText = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont");

  let mode = gameController.getCurrentMode();
  let target = mode === "LuckyBet" ? gameController.goldenBetRespinsTriggerCount : gameController.respinsTriggerCount;

  cloverCountText.text = gameController.cloverSpinsCurrent;

  let coinAmount = gameController.coinCollectCurrent;

  if (CloverRespins.respinData && !CloverRespins.completed) {
    if (gameController.cloversAdded && CloverRespins.respinData.isAwarded) {
      gameController.cloverSpinsCurrent =
        CloverRespins.currentSpin === undefined
          ? CloverRespins.respinData.numberOfRespinsAwarded
          : CloverRespins.currentSpin;
      cloverCountText.text =
        CloverRespins.currentSpin === undefined
          ? CloverRespins.respinData.numberOfRespinsAwarded
          : CloverRespins.currentSpin;
    }

    if (mode === "LuckyBet") {
      coinAmount = CloverRespins.respinData.isAwarded ? 25 : gameController.coinCollectCurrent;

      if (coinAmount <= 25) {
        coinCounterText.text = `${coinAmount}/${target}`;
      }
    } else {
      coinAmount = CloverRespins.respinData.isAwarded ? 50 : gameController.coinCollectCurrent;

      if (coinAmount <= 50) {
        coinCounterText.text = `${coinAmount}/${target}`;
      }
    }
  } else {
    coinCounterText.text = `${coinAmount}/${target}`;
  }

  let currentCoinCollectFill;
  if (mode === "LuckyBet") {
    coinCollectGreenFill.visible = false;
    currentCoinCollectFill = coinCollectGoldFill;
  } else {
    coinCollectGoldFill.visible = false;
    currentCoinCollectFill = coinCollectGreenFill;
  }

  // set coin counter progress mask
  if (!gameController.inFreeSpins || gameController.freeSpinsTransitionOut) {
    currentCoinCollectFill.visible = true;
  }

  // THERES PADDING ON THE FILL BAR SO IT ACTUALLY LOOKS FILLED UP AT 44 AND NOT 50 (22 NOT 25 FOR GOLDENBET (landscape))
  const layout = layoutController.getCurrentLayout();
  const landscapeMobile = layout === "landscape_mobile";
  let visualMax;
  if (systemData.isLandscape && !landscapeMobile) {
    visualMax = mode === "LuckyBet" ? 22 : 44;
  } else {
    visualMax = mode === "LuckyBet" ? 25 : 49;
  }

  const percentage = Math.min(coinAmount / target, 1);
  const width = currentCoinCollectFill.width * (percentage * (visualMax / target));
  const height = currentCoinCollectFill.height;

  const leftEdge = currentCoinCollectFill.parent.x;
  const topEdge = currentCoinCollectFill.parent.y;

  coinCollectGreenFillMask.clear();
  coinCollectGreenFillMask.beginFill(0xffffff);
  coinCollectGreenFillMask.drawRect(0, 0, width, height);
  coinCollectGreenFillMask.endFill();

  coinCollectGreenFillMask.x = leftEdge;
  coinCollectGreenFillMask.y = topEdge;

  currentCoinCollectFill.mask = coinCollectGreenFillMask;

  if (
    CloverRespins.respinData &&
    CloverRespins.respinData.isAwarded &&
    !CloverRespins.inProgress &&
    !CloverRespins.completed &&
    !orientationChange
  ) {
    if (mode === "LuckyBet") {
      gameController.coinCollectGoldFillCompletion.visible = true;
      gameController.coinCollectGoldFillCompletion.play();

      gameController.coinCollectGoldFillCompletion.onComplete = () => {
        gameController.coinCollectGoldFillCompletion.visible = false;
        gameController.coinCollectGoldFillCompletion.gotoAndStop(0);
      };
    } else {
      gameController.coinCollectGreenFillCompletion.visible = true;
      gameController.coinCollectGreenFillCompletion.play();
      gameController.coinCollectGreenFillCompletion.onComplete = () => {
        gameController.coinCollectGreenFillCompletion.visible = false;
        gameController.coinCollectGreenFillCompletion.gotoAndStop(0);
      };
    }
  }
};

gameController.getPersistentValues = function (stake) {
  let mode = gameController.getCurrentMode();
  if (mode === "LuckyBet") {
    stake = stake / 1.5;
  } else {
    mode = "Basic";
  }
  let playerActivationCount;
  let cloverCount;
  if (Object.keys(gameController.persistentValues[mode]).includes("Stake_" + stake, 0) === false) {
    // then select the lowest available stake - used for org=minBet
    playerActivationCount = Object.values(gameController.persistentValues[mode])[0].playerActivationCount;
    cloverCount = Object.values(gameController.persistentValues[mode])[0].cloverCount;
  } else {
    playerActivationCount = gameController.persistentValues[mode]["Stake_" + stake].playerActivationCount;
    cloverCount = gameController.persistentValues[mode]["Stake_" + stake].cloverCount;
  }

  let persistentValues = {
    playerActivationCount: playerActivationCount,
    cloverCount: cloverCount,
    stake: stake,
  };

  return persistentValues;
};

gameController.convertMode = function (mode) {
  switch (mode) {
    case "Basic": {
      return "BASIC";
    }
    case "LuckyBet": {
      return "LUCKYBET_BUY";
    }
    case "BonusBuyLow": {
      return "BONUS_BUY_LOW";
    }
    case "BonusBuyMedium": {
      return "BONUS_BUY_MED";
    }
    case "BonusBuyHigh": {
      return "BONUS_BUY_HIGH";
    }
    case "default": {
      return "BASIC";
    }
  }
};

gameController.getCurrentMode = function () {
  let mode;

  if (gameController.inBuyABonusLow) {
    mode = "BonusBuyLow";
  } else if (gameController.inBuyABonusMed) {
    mode = "BonusBuyMedium";
  } else if (gameController.inBuyABonusHigh) {
    mode = "BonusBuyHigh";
  } else if (gameData.encoreEnabled) {
    //lucky/golden bet mode
    mode = "LuckyBet";
  } else {
    mode = "Basic";
  }

  return mode;
};

gameController.getCurrentModeStake = function (mode) {
  let stake = 0;

  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    stake = stakeController.getCurrentStake(mode);

    if (gameController.inBuyABonus) {
      stake = stakeController.getCurrentStake(gameController.buyBonusMode);
    }
  }
  return stake;
};

gameController.startReelAnticipation = function (reel) {
  if (gameController.slotMachine && !gameController.slamStopped) {
    gameController.slotMachine._currentMode.stopDistances[reel] += 25;
    let anticipationMovie = resourceManager.get("postReels:reel4Anticipation");
    anticipationMovie.visible = true;
    anticipationMovie.gotoAndPlay(0);
    gameController.anticipating = true;
    musicManager.fadeForAnticipation();
  }
};

gameController.stopReelAnticipation = function () {
  if (gameController.slotMachine && gameController.anticipationTriggered) {
    musicManager.onAnticipationEnd();
  }
  let anticipationMovie = resourceManager.get("postReels:reel4Anticipation");
  anticipationMovie.visible = false;
  anticipationMovie.gotoAndStop(0);
  gameController.slotMachine.clearDimSymbolIds();
  gameController.anticipating = false;
  gameController.landAnimationsPlaying = false;
};

gameController.setupSlotAnimVisuals = function () {
  let anticipation = particleManager.createEmitter("anticipation", "particlesContainerFront", 0, 0, false);
  anticipation.particleEmitter.emit = false;
  anticipation.visible = false;
  let anticipationAnim = {
    emitter: anticipation,
    timeline: undefined,
  };
  gameController.anticipationEmitter = anticipationAnim;
};

gameController.playLandSounds = function (reel) {
  // gameController.coinID = 18;
  // gameController.bonusID = 12;
  // gameController.cloverID = [15, 16, 17];
  // gameController.potID = 19
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);

  soundManager.play("reelStop" + reel);
  if (gameController.checkForSymbolOnReels(reel, gameController.bonusID)) {
    soundManager.play("bonusLand");
  } else if (gameController.checkForSymbolOnReels(reel, gameController.potID)) {
    soundManager.play("horseshoeLand");
  } else if (gameController.checkForSymbolOnReels(reel, gameController.coinID)) {
    soundManager.play("coinLand");
  } else if (gameController.checkForSymbolOnReels(reel, gameController.collectID) && !reelVisual.sliding) {
    soundManager.play("collectLand");
  } else {
    for (const clover of gameController.cloverID) {
      if (gameController.checkForSymbolOnReels(reel, clover)) {
        soundManager.play("cloverLand");
      }
    }
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  gameController.previousSavedResult = gameController.previousResult;
  gameController.previousResult = gameController.spinTask.data.resultPanel.reelList;
  gameController.previousResult.inFreeSpins = gameController.inFreeSpins;
  gameController.skippingWayWins = false;

  gameController.spinComplete = true;
  gameController._receivedResponse = true;
  soundManager.stop("reelspin");
  gameController.slotMachine.clearDimSymbolIds();
  gameController.stateMachine.switchState("WAITING_FOR_REELS");
  // gameController.setState_WaitingForServer(gameController.spinTask);

  gameController.emptyTweenArrays();
};

gameController.getIsRecovery = function () {
  return gameController.inRecovery;
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  return gameController.coins.some((coin) => coin.type === "Bonus");
};

gameController.isBonusPossible = function (reel) {
  switch (reel) {
    case 0: {
      return true;
    }
    case 1: {
      return gameController.bonusSymbolsLanded !== 0;
    }
    case 2: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 3: {
      return gameController.bonusSymbolsLanded >= 2;
    }
    case 4: {
      return gameController.bonusSymbolsLanded >= 3;
    }
  }
};

gameController.animateBackgroundAssets = function () {};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols = gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "Bonus") +
    gameController.countSymbolOnReel(reel, "Bonus_x4") +
    gameController.countSymbolOnReel(reel, "Bonus_x5") +
    gameController.countSymbolOnReel(reel, "Bonus_x6") +
    gameController.countSymbolOnReel(reel, "Bonus_x7")
  );
};

gameController.countCollectOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "Collect") +
    gameController.countSymbolOnReel(reel, "Collect_x4") +
    gameController.countSymbolOnReel(reel, "Collect_x5") +
    gameController.countSymbolOnReel(reel, "Collect_x6") +
    gameController.countSymbolOnReel(reel, "Collect_x7")
  );
};

gameController.countCoinsOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "Coin") +
    gameController.countSymbolOnReel(reel, "Coin_x4") +
    gameController.countSymbolOnReel(reel, "Coin_x5") +
    gameController.countSymbolOnReel(reel, "Coin_x6") +
    gameController.countSymbolOnReel(reel, "Coin_x7")
  );
};

gameController.countPotsOnReel = function (reel) {
  return (
    gameController.countSymbolOnReel(reel, "Horseshoe") +
    gameController.countSymbolOnReel(reel, "Horseshoe_x4") +
    gameController.countSymbolOnReel(reel, "Horseshoe_x5") +
    gameController.countSymbolOnReel(reel, "Horseshoe_x6") +
    gameController.countSymbolOnReel(reel, "Horseshoe_x7")
  );
};

gameController.countLogoOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Logo");
};

gameController.countTotalCoinValueOnReels = function () {
  let value = 0;
  let coins = gameController.spinTask.data.coins;
  for (let i = 0; i < coins.length; i++) {
    value += coins[i].amount;
  }
  return value;
};

gameController.onSpinLand = function (reel) {
  if (reel === 4) {
    gameController.stopReelAnticipation();
  }
  if (gameController.inFreeSpins) {
    if (reel === 0 || reel === 4) {
      gameController.checkSlidingSymbol(reel);
    }
  }
};

gameController.onNudgeSpinLand = function (reel) {};

/**
 * Free Spins Sliding collect
 *
 */
gameController.checkSlidingSymbol = function (reel) {
  const reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const collectID = 54;
  const collectPresent = gameController.checkForCollectOnReels(reel, collectID);
  const row = gameController.getCollectSymbolRow(collectID, reel);

  const lastOnReel = row === 2;
  const slidingCollectOnReel = gameController.currentSlidingCollects.find(
    (slidingCollect) => slidingCollect.reel === reel
  );

  if (collectPresent && !lastOnReel && !slidingCollectOnReel) {
    const row = gameController.getCollectSymbolRow(collectID, reel);
    const slidingCollect = reelVisual.getSlidingCollectFromPool();
    const symbol = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);

    const localToGlobalPos = helper.getLocalFromGlobalPosition(symbol, slidingCollect.spine);

    //spine
    slidingCollect.spine.x = localToGlobalPos.x;
    slidingCollect.spine.y = localToGlobalPos.y;
    slidingCollect.spine.slidesRemaining = 2 - row;
    slidingCollect.spine.reel = reel;

    slidingCollect.spine.backing = 2 - row;

    //backing
    //slidingCollect.backing.y = yPos;

    setTimeout(
      function () {
        //gameController.fadeInSlidingCollect(slidingCollect.backing);
        gameController.fadeInSlidingCollect(slidingCollect.spine);
      }.bind(this),
      200
    );

    gameController.slidingOverlays.push(slidingCollect.spine);
    //gameController.slidingOverlayBackings.push(slidingCollect.backing);
    gameController.currentSlidingCollects.push(slidingCollect);
  }
};

gameController.fadeInSlidingCollect = function (object) {
  gsap.fromTo(
    object,
    {
      visible: true,
      alpha: 0,
    },
    {
      duration: 0.2,
      alpha: 1,
    }
  );
};

gameController.getCollectSymbolRow = function (collectID, reel) {
  for (let row = 0; row < 3; row++) {
    if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === collectID) return row;
  }
};

gameController.slideCollectDown = function () {
  let height = resourceManager.get("slotContainer:reelContainer:reel0:symbol0").height;
  let duration = 0.5;

  const toRemove = [];
  gameController.currentSlidingCollects.forEach(function (slidingCollect) {
    const overlay = slidingCollect.spine;

    if (overlay.slidesRemaining === 0) {
      toRemove.push(slidingCollect);
    } else {
      //const backing = slidingCollect.backing;
      overlay.play("Fisherman_Regular");
      overlay.slidesRemaining--;

      gameController.overlayDownTweens.push(
        gsap.to(overlay, {
          duration: duration,
          y: overlay.y + height,
          ease: "power4.in",
          onComplete: () => {
            soundManager.play("collectLand");
          },
        })
      );
    }
  });

  toRemove.forEach((rem) => {
    gameController.removeSlidingCollect(rem);
  });
};

gameController.removeSlidingCollect = function (slidingCollect) {
  slidingCollect.spine.visible = false;
  //slidingCollect.backing.visible = false;
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + slidingCollect.spine.reel);
  reelVisual.slidingCollectPool.push(slidingCollect);
  gameController.currentSlidingCollects.splice(gameController.currentSlidingCollects.indexOf(slidingCollect), 1);
};

gameController.removeSlidingOverlays = function () {
  gameController.emptyTweenArrays();
  gameController.currentSlidingCollects.forEach((slidingCollect) => {
    slidingCollect.spine.visible = false;
    //slidingCollect.backing.visible = false;
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + slidingCollect.spine.reel);
    reelVisual.slidingCollectPool.push(slidingCollect);
  });
  while (gameController.currentSlidingCollects.length) {
    gameController.currentSlidingCollects.shift();
  }
  gameController.slidingOverlays = [];
  gameController.slidingOverlayBackings = [];
};

gameController.onSpinHit = function (reel) {
  //Anticipation
  if (gameController.anticipationTriggered && reel === 3) {
    gameController.startReelAnticipation(reel + 1);
  }

  gameController.landedReels[reel] = true;

  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  reelVisual.coinDisplayMode = true;
  reelVisual.sliding = false;

  let found = undefined;
  let symbolsToAnimate = [];
  let bonusSymbolFound = false;
  let nudgeSymbolFound = false;

  for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; ++row) {
    let symData = {
      cell: { reel: reel, row: row },
      symbolId: gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value,
    };

    gameController.symbolMap.push(symData);

    // Bonus symbol
    if (gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === 15) {
      found = {
        row,
        id: gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value,
      };
      let symData = {
        cell: { reel: reel, row: found.row },
        symbolId: found.id,
      };
      symbolsToAnimate.push(symData);
      bonusSymbolFound = true;
    }

    const fishermanId = 14;
    const respinIds = [15, 16, 17];

    let originalSymbolValue;

    const currentValue = gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value;

    if (currentValue >= 100) {
      originalSymbolValue = 18;
    } else {
      originalSymbolValue = currentValue % 20;
    }

    const isFisherman = originalSymbolValue === fishermanId && !gameController.checkIfCollectIsSliding(reel);

    // const isRespin = false; //respinIds.includes(originalSymbolValue);

    // if (isFisherman) {
    //   gameController.landAnimationsPlaying = true;
    //   gameController.numberOfLandAnimationsPlaying++;
    //   symbolLandAnimator.animate([symData], gameController.isLandAnimationStillPlaying.bind(this), 0);
    // }
  }

  let reel0Size = gameController.spinTask.data.resultPanel.reelList[0].symbols.length;
  let reel1Size = gameController.spinTask.data.resultPanel.reelList[1].symbols.length;
  let reel2Size = gameController.spinTask.data.resultPanel.reelList[2].symbols.length;
  let reel3Size = gameController.spinTask.data.resultPanel.reelList[3].symbols.length;
  let reel4Size = gameController.spinTask.data.resultPanel.reelList[0].symbols.length;

  if (reel === 0) {
    gameController.winWaysValue = reel0Size;
  }
  if (reel === 1) {
    gameController.winWaysValue = reel0Size * reel1Size;
  }
  if (reel === 2) {
    gameController.winWaysValue = reel0Size * reel1Size * reel2Size;
  }
  if (reel === 3) {
    gameController.winWaysValue = reel0Size * reel1Size * reel2Size * reel3Size;
  }
  if (reel === 4) {
    gameController.winWaysValue = reel0Size * reel1Size * reel2Size * reel3Size * reel4Size;
  }
  gameController.desktopWinWaysCounter.setText(gameController.winWaysValue);
  //gameController.mobileWinWaysCounter.setText(gameController.winWaysValue);
  gameData.reelsSpinning--;
};

gameController.isLandAnimationStillPlaying = function () {
  gameController.numberOfLandAnimationsPlaying--;
  if (gameController.numberOfLandAnimationsPlaying <= 0) {
    gameController.landAnimationsPlaying = false;
  }

  if (!gameController.landAnimationsPlaying) {
    gameController.numberOfLandAnimationsPlaying = 0;
  }
};

gameController.SeedUIGenerator = function (Seed) {
  gameController.UIRandomSeed = Seed;
  gameController.UINumGenerator = helper.GeneratorPotSpinsVariationSplitMix32(gameController.UIRandomSeed);
};

gameController.doSpin = function (spinTask) {
  for (let i = 0; i < 5; i++) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.coinDisplayMode = false;
    reelVisual.multiplierStakeForCurrentSpin = gameController.getMultiplierStake();
    reelVisual.sliding = false;
  }
  soundManager.play("spinPress");
  if (gameController.inFreeSpins) {
    gameController.clearLockedCoins();
  }
  gameController.spinTask = spinTask;
  gameController.isPrePaid = spinTask.data.isPrePaidGame;
  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameController.skippingWayWins = false;

  gameController.SeedUIGenerator(spinTask.data.UIRandomSeed);

  //ANTICIPATION
  gameController.longSpinReels = [false, false, false, false, false];
  let numBonus = 0;

  if (gameController.slidingOverlays.length > 0) {
    gameController.slideCollectDown();
  }

  gameController._receivedResponse = true;

  gameData.reelsSpinning = gameData.numReels;

  gameController.cyclingWinlines = false;

  gameData.nudgeReelsSpinning = 5;

  gameController.logoSymbolAnticipationReel = -1;

  if (gameController.inBuyABonus && gameController.inBuyABonusFirstSpin) {
    gameController.longSpinReels = [false, false, false, false, true];
  }
  gameController.inBuyABonusFirstSpin = false;

  for (let i = 0; i < gameController.longSpinReels; i++) {
    numBonus += gameController.countBonusOnReel(i);
  }

  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (var reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (let row = 0; row < spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
      symbols[reel].push(spinTask.data.resultPanel.reelList[reel].symbols[row].value);
    }
    for (let row = 0; row < spinTask.data.resultPanel.symbolsAbove[reel].symbols.length; row++) {
      above[reel].push(spinTask.data.resultPanel.symbolsAbove[reel].symbols[row].value);
    }
    for (let row = 0; row < spinTask.data.resultPanel.symbolsBelow[reel].symbols.length; row++) {
      below[reel].push(spinTask.data.resultPanel.symbolsBelow[reel].symbols[row].value);
    }
  }

  // Set dynamic symbol heights
  for (let i = 0; i < spinTask.data.resultPanel.reelList.length; i++) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.spawnedAnticipationSymbol = false;

    for (let index = 0; index < spinTask.data.resultPanel.reelList[i].symbols.length; index++) {
      helper.getSymbolName(spinTask.data.resultPanel.reelList[i].symbols[index].value);
    }

    if (i === 0 || i === 4) {
      reelVisual.setAppertureHeight(5);
    } else if (i === 1) {
      reelVisual.setAppertureHeight(spinTask.data.resultPanel.reelList[1].symbols.length);
    } else if (i === 2) {
      reelVisual.setAppertureHeight(spinTask.data.resultPanel.reelList[2].symbols.length);
    } else if (i === 3) {
      reelVisual.setAppertureHeight(spinTask.data.resultPanel.reelList[3].symbols.length);
    }
  }

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();

  gameController.coins = spinTask.data.coins;
  CloverRespins.respinData = spinTask.data.cloverRespins;
  gameController.goldenSpins = spinTask.data.goldenSpins;
  GoldenSpins.goldenSpins = spinTask.data.goldenSpins;
  gameController.coinAwards = spinTask.data.coinAwards;
  gameController.anticipationTriggered = spinTask.data.anticipationTriggered;
  console.log("TotalWin: " + gameController.totalWin + " Total Winnings: " + gameController.totalWinnings);
  if (!gameController.inFreeSpins) {
    gameController.totalWinnings = spinTask.data.totalWinnings !== undefined ? spinTask.data.totalWinnings : 0;
    gameController.totalWin = spinTask.data.totalWinnings !== undefined ? spinTask.data.totalWinnings : 0;
  } else {
    gameController.totalWinnings = spinTask.data.winAmountSoFar + gameController.amountWonInBaseGame;
  }
  if (
    (spinTask.data.coinAwardsBeforeGoldenSpins && spinTask.data.coinAwardsBeforeGoldenSpins.winAmount > 0) ||
    (spinTask.data.goldenSpins && spinTask.data.goldenSpins.winAmount > 0)
  ) {
    gameController.hasCoinWin = true;
  } else {
    gameController.hasCoinWin = false;
  }
  gameController.winningLines = spinTask.data.lines;

  // Anticipation
  if (gameController.anticipationTriggered) {
    for (let i = 0; i < gameController.longSpinReels.length; i++) {
      gameController.longSpinReels[i] = false;
    }
    gameController.longSpinReels[3] = true;
  }

  gameController.slotMachine._currentMode.stopDistances = gameController.originalStopDistances;
  let newStopDistances = [];
  for (let r = 0; r < gameController.longSpinReels.length; ++r) {
    newStopDistances.push(gameController.originalStopDistances[r]);
    if (gameController.longSpinReels[r]) {
      newStopDistances[r] = 30;
    } else {
      newStopDistances[r] = gameController.originalStopDistances[r];
    }
  }
  gameController.slotMachine._currentMode.stopDistances = newStopDistances;

  gameController.isFreeSpinsTrigger = !gameController.inFreeSpins && gameController.coinAwards.freeSpinsAwarded > 0;

  gameController.slotMachine.stopReels(symbols, above, below, gameController.onSpinComplete);
};

gameController.clearLockedCoins = function () {
  if (gameController.coins) {
    gameController.lockedCoins.forEach(function (coin) {
      resourceManager.destroyObject(coin.name);
    });
    gameController.lockedCoins = [];
  }
};

gameController.initNewSpin = function (recoveryBonusBuy = false) {
  luckyBetToggleButton.hideMessage();
  musicManager.onGameStart();

  gameController.symbolMap = [];
  gameController.winGroups = [];
  CoinsView.HideGoldenBet = false;

  gameController._receivedResponse = false;

  if (gameData.winningsText) {
    gameData.winningsText.show(false);
  } else {
    gameData.winningsText = resourceManager.get("winningsTextMasterContainer:winningsText");
    gameData.winningsText.show(false);
  }

  symbolWinBorderAnim.skip();
  symbolAnimator.skip();
  //spineSymbolAnimator.skip();
  symbolLandAnimator.skip();
  gameController.skippingWayWins = true;
  gameController.slotMachine.clearDimSymbolIds();

  // for (let i = 0; i < 5; i++) {
  //   let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
  //   reelVisual.coinDisplayMode = false;
  //   reelVisual.multiplierStakeForCurrentSpin = gameController.getMultiplierStake();
  //   reelVisual.sliding = false;
  // }

  gameController.anticipating = false;
  gameController.canSlamStop = true;
  gameController.slamStopped = false;
  gameController.bonusSymbolsLanded = 0;
  gameController.landAnimationsPlaying = false;
  gameController.cyclingWins = false;
  gameController.cloversAdded = false;
  gameController.bigWin._newSpin = true;
  gameData.winningsText.skip();
  PrizePots.PotPrizes = [];
  PrizePots.cleanUp();
  CoinsView.cleanUp();
  CoinsView.canSkipCoins = false;
  GoldenSpins.goldSpinsCompleted = [];
  CoinsView.PotsSavedForSkippFunction = [];
  GoldenSpins.isGoldenSpin = false;
  GoldenSpins.currentSpin = undefined;
  gameController.previousWinnings = 0;
  gameController.coinWinnings = 0;
  gameController.cyclingWinsIndex = 0;
  //winlineAnimationController.skipAnimations();
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.nudgeSpinComplete = false;
  CloverRespins.currentSpin = undefined;
  if (!this.inFreeSpins) {
    CloverRespins.completed = false;
  }

  gameController.winWaysValue = "";
  gameController.desktopWinWaysCounter.setText(gameController.winWaysValue);
  //gameController.mobileWinWaysCounter.setText(gameController.winWaysValue);

  // gameController.winningsContainer.visible = false;
  if (!gameController.inFreeSpins) {
    gameData.winningsMeter.set(0);
  }

  timerManager.stop(gameController.timerFadeSpinsLoopIntoIdle);
  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }

  if (!gameController.inFreeSpins && !autoplayManager.isAutoplayEnabled()) {
    gameController.currentReelSpin = soundManager.play("reelSpin");
  }
  gameController.symbolAnimator.skip();
  gameController.symbolLandAnimator.skip();

  gameController.stoppedReels = [false, false, false, false, false];
  gameController.landedReels = [false, false, false, false, false];

  gameController.spinHasMushroomPrizes = false;

  if (!recoveryBonusBuy) {
    gameController.slotMachine.infiniteSpin();
  }

  gameController.slotMachine.dimAllSymbols(false, 0.1);

  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;
};

gameController.getMultiplierStake = function () {
  if (gameController.inBuyABonus) {
    return gameController.bonusBetStake / 100;
  }
  if (gameData.currentStakeIndex === -1) {
    return gameData.stakes[0] / 100;
  }
  return gameData.stakes[gameData.currentStakeIndex] / 100; //base stake?
};

gameController.initNewGame = function (recovery = false) {
  gameController.inBuyABonus = false;
  gameController.inBuyABonusLow = false;
  gameController.inBuyABonusMed = false;
  gameController.inBuyABonusHigh = false;
  gameController.stopCyclingWins();

  gameController.canSkipWin = false;
  gameController.skippingWayWins = false;

  gameController.clearLockedCoins();
  PrizePots.cleanUp();
  symbolWinBorderAnim.stopAllAnimations();
  gameController.winGroups = [];
  gameController.symbolsToAnimate = [];
  gameData.winningsText.show(false);
  spineSymbolAnimator.skip();
  symbolAnimator.skip();
  gameController.slotMachine.clearDimSymbolIds();
  gameController.cyclingWins = false;

  gameController.longSpinReels = [false, false, false, false, false];
  let numBonus = 0;

  gameController.cashCoinAmountText.visible = false;
  gameController.cashCoinAmountContainer.visible = false;
  gameController.arrCount = 0;
  gameController.currentWinnings = 0;
  gameController.previousWinnings = 0;
  gameController.totalWin = 0;

  gameController.inBuyABonusFirstSpin = true;
  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");
  gameController.slotMachine.selectReelMode("default");

  if (!recovery) {
    gameController.initNewSpin();
  } else {
    // make sure symbol are correct
    // especially on br license and restore
    gameController.slotMachine.update(0);
  }
  if (autoplayManager.isAutoplayEnabled()) {
    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", String(autoplayManager.getRemainingRounds() - 1));
  }
};

gameController.startGame = function () {
  // Do not allow the user to spin if the buy bonus panel is up
  let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");

  //move all this logic here.
  gameController.stopCyclingWins();

  if (buyBonusPopUp.visible) return;

  gameController.justHadFreeSpins = false;
  gameController.initNewGame();
  const stakeController = resourceManager.getController("stakeController");
  let bpl = stakeController.BaseStake / 1;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: 1,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.dimAllSymbols = function (dim) {
  for (let reel = 0; reel < gameData.reels.length; reel++) {
    for (let row = 0; row < gameData.reels[reel].appertureHeight + 1; row++) {
      let symID = gameController.slotMachine.getSymbolId(reel, row);
      gameController.slotMachine.dimSymbol(reel, row, dim, 0.1);
    }
  }
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreeSpins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.checkForSymbolOnReels = function (reel, symbol) {
  for (let row = 0; row < gameController.spinTask.data.resultPanel.reelList[reel].symbols.length; row++) {
    let symbolValue = gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value;
    // if its a "made up ID" of 100 or over, then it's a cash fish. Cash fish ID is actually 18
    if (symbolValue >= 100) {
      symbolValue = 18;
    }

    if (symbolValue % 20 === symbol) {
      return true;
    }
  }
  return false;
};

gameController.checkForCollectOnReels = function (reel, symbol) {
  for (let row = 0; row < 3; row++) {
    if (
      gameController.previousResult.length === 0 &&
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol
    ) {
      return true;
    } else if (gameController.previousResult.length > 0) {
      if (row === 0 && gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol) {
        return true;
      }
      if (
        gameController.previousResult.length > 0 &&
        gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol &&
        gameController.previousResult[reel].symbols[row - 1].value !== symbol
      ) {
        return true;
      } else if (
        row === 2 &&
        gameController.spinTask.data.resultPanel.reelList[reel].symbols[row].value === symbol &&
        gameController.previousResult[reel].symbols[row].value === symbol
      ) {
        return true;
      }
    }
  }
  return false;
};

gameController.checkIfCollectIsSliding = function (reel) {
  if (
    !gameController.inFreeSpins ||
    gameController.previousResult === undefined ||
    (gameController.previousResult !== undefined && !gameController.previousResult.inFreeSpins)
  ) {
    return false;
  }

  for (let row = 0; row < 3; row++) {
    const currRow = gameController.spinTask.data.resultPanel.reelList[reel].symbols[row];
    if (currRow.value === 54) {
      const previousRow = gameController.previousResult[reel].symbols[row - 1];
      if (previousRow !== undefined) {
        if (previousRow.value === 54) {
          return true;
        }
      }
    }
  }
  return false;
};

gameController.addCloverSymbolsToCount = function () {
  let cloversymbols = [55, 56, 57];
  let cloverFound = false;
  for (let row = 0; row < 3; row++) {
    let index = cloversymbols.indexOf(gameController.spinTask.data.resultPanel.reelList[4].symbols[row].value);
    if (index >= 0) {
      cloverFound = true;
      gameController.cloverSpinsCurrent += index + 1;
      let symbol = [
        {
          symbolId: cloversymbols[index],
          cell: {
            reel: 4,
            row: row,
          },
        },
      ];
      gameController.addToCloverCounter(index, symbol[0]);
    }
  }
  if (!cloverFound) {
    gameController.cloversAdded = true;
  }
};

gameController.addToCloverCounter = function (index, symbol) {
  symbolAnimator.animate([symbol], () => {
    //gameController.pulseClover();
    gameController.moveCloverToCounter(symbol);
  });
  gameController.scaleAndUpdateCounter();
};

gameController.getCloverSymbolsPos = function (reel, row) {
  const xPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}`);
  const yPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol${row}`);

  const pos = {
    x: xPos.x + yPos.width / 2,
    y: yPos.y + xPos.y + yPos.symbol.height / 2,
  };

  return pos;
};

gameController.moveCloverToCounter = async function (symbol) {
  const symbolAsset = resourceManager.get(
    `slotContainer:reelContainer:reel${symbol.cell.reel}:symbol${symbol.cell.row}`
  );

  const symbolPos = helper.getLocalFromGlobalPosition(symbolAsset, gameController.cloverEmitter);

  gameController.cloverEmitter.particleEmitter.spawnPos = {
    x: symbolPos.x,
    y: symbolPos.y,
  };

  gameController.cloverEmitter.particleEmitter.emit = true;
  gameController.cloverEmitter.visible = true;

  const rapidRespinsMeterCount = resourceManager.get("postReels:rapidRespinsContainer:rapidRespinsMeterCount");

  const xOnlyTween = SmartTweens.tween(
    gameController.cloverEmitter.particleEmitter.spawnPos,
    rapidRespinsMeterCount,
    gameController.cloverEmitter,
    { ease: "linear", duration: 0.5, y: false },
    false
  );

  const yOnlyTween = SmartTweens.tween(
    gameController.cloverEmitter.particleEmitter.spawnPos,
    rapidRespinsMeterCount,
    gameController.cloverEmitter,
    { ease: "power3.in", duration: 0.5, x: false },
    false
  );

  await Promise.all([xOnlyTween, yOnlyTween]);

  gameController.cloverEmitter.particleEmitter.emit = false;
  gameController.cloverEmitter.visible = false;
};

gameController.pulseClover = function () {
  gsap.to(this.cloverSprite.scale, {
    delay: 0.2,
    duration: 0.3,
    x: 0.2,
    y: 0.2,
    onComplete: () => {
      this.cloverSprite.visible = false;
      resourceManager.destroyObject(this.cloverSprite.name);
    },
  });
};

gameController.scaleAndUpdateCounter = function () {
  let cloverText = resourceManager.get("postReels:rapidRespinsContainer:rapidRespinsMeterCount");

  const originalTextScale = cloverText.scale.x;
  gsap
    .timeline()
    .to(cloverText.scale, {
      duration: 1,
      x: originalTextScale * 1.3,
      y: originalTextScale * 1.3,
      onComplete: () => {
        gameController.cloversAdded = true;
        if (!gameData.slotConfig.inReplayMode) {
          gameController.updateCounterState(gameController.globalHelperGetCurrentModeStake());
        }
        gameController.updateCounters();
      },
    })
    .to(cloverText.scale, {
      duration: 0.5,
      x: originalTextScale,
      y: originalTextScale,
      onComplete: () => {},
    });
};

gameController.lockCoins = function () {
  if (gameController.coins.length > 0) {
    gameController.coins.forEach(function (coin) {
      // let height = resourceManager.get(`slotContainer:reelContainer:reel${coin.coord.reel}:symbol0`).height;
      // let width = resourceManager.get(`slotContainer:reelContainer:reel${coin.coord.reel}:symbol0`).width;
      const coinPositioning = gameController.calculateCoinLockScale(coin.coord.reel);

      const coinLock = resourceManager.createObject(
        "movie",
        `lockedCoins:reel${coin.coord.reel}:symbol${coin.coord.row}`,
        `slotContainer:reelContainer:reel${coin.coord.reel}`,
        {
          definition: "coinLock",
          x: 0,
          y: 0,
          loop: true,
          anchor: 0.5,
          scaleY: coinPositioning.scale,
          scaleX: 1,
        }
      );

      const symbol = resourceManager.get(`slotContainer:reelContainer:reel${coin.coord.reel}:symbol${coin.coord.row}`);
      const symbolPos = helper.getLocalFromGlobalPosition(symbol, coinLock);

      coinLock.x = symbolPos.x;
      coinLock.y = symbolPos.y - coinPositioning.yOffset;

      const pulseTween = gsap.fromTo(
        coinLock.scale,
        {
          x: 1,
          y: coinPositioning.scale,
        },
        {
          paused: true,
          delay: 0,
          duration: 0.5,
          x: 1.05,
          y: coinPositioning.scale * 1.05,
          yoyo: true,
          repeat: 1,
        }
      );
      pulseTween.time(0).restart(true);
      coinLock.gotoAndStop(0);
      coinLock.play();
      gameController.lockedCoins.push(coinLock);
    });
  }
};

gameController.calculateCoinLockScale = function (reel) {
  let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  let appertureHeight = reelVisual.appertureHeight;
  switch (appertureHeight) {
    case 3:
      return { scale: 1, yOffset: 0 };
    case 4:
      return { scale: 0.75, yOffset: 0 };
    case 5:
      return { scale: 0.6, yOffset: 0 };
    case 6:
      return { scale: 0.5, yOffset: 0 };
    case 7:
      return { scale: 0.43, yOffset: 0 };
  }
};

gameController.autoplayStarted = function (autoplayData) {
  autoplayManager.dialog.buttonGlow = resourceManager.get("buttonContainer:buttonBar:autoplayButton:glow");

  autoplayManager.dialog.buttonGlow.visible = true;
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager.getController("inputOverlord").setText("autoplayCancelButton", "");

  resourceManager.get("buttonContainer:buttonBar:autoplayButton:glow").visible = false;
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController("autoplayController").cancel();

  resourceManager.get("buttonContainer:buttonBar:autoplayButton:glow").visible = false;
};

gameController.stateMachine.addState("WAITING_FOR_REELS", function () {
  if (gameController.phase.once()) {
    gameController.cloversAdded = false;
    gameController.newCloversFound = false;
    gameController.addCloverSymbolsToCount();
  }

  if (gameController.phase.hold()) {
    if (
      (gameController.cloversAdded === true && gameController.landAnimationsPlaying === false) ||
      (gameController.cloversAdded === true && gameController.slamStopped)
    ) {
      gameController.phase.step();
      gameController.setState_WaitingForServer(gameController.spinTask);
    }
  }
});

gameController.stateMachine.addState("WAITING_FOR_BONUSES", function () {
  if (gameController.phase.hold()) {
    gameController.phase.step();
  }

  if (gameController.phase.once()) {
    PrizePots.awardPrizePot();
  }

  if (gameController.phase.hold()) {
    if (gameController.prizePotAnimationsComplete === true) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (gameController.isBonusThisSpin()) {
      soundManager.play("bonusWon");
      gameController.delay(500);
      gameController.cashCoinsAnimationsComplete = false;
      CoinCollectionController.doCollection();
      //CoinsView.doCashCoins();
    } else {
      gameController.cashCoinsAnimationsComplete = false;
      //CoinsView.doCashCoins();
      CoinCollectionController.doCollection();
    }
  }

  if (gameController.phase.hold()) {
    if (gameController.cashCoinsAnimationsComplete === true) {
      gameController.cloverRespinsComplete = false;
      gameController.phase.step();
    }
  }

  if (gameController.phase.hold()) {
    if (gameController.cashCoinsAnimationsComplete) {
      if (gameController.inFreeSpins) {
        //gameController.totalWinnings += gameController.coinWinnings;
        if (gameController.coinWinnings > 0) {
          gsap.to(gameData.winningsMeter.scale, {
            duration: 0.3,
            ease: "power1.inOut",
            x: 1.25,
            y: 1.25,
            repeat: 1,
            yoyo: true,
          });
          gameData.winningsMeter.set(gameController.totalWinnings);
          soundManager.play("addToCreditFS");
          gameController.coinWinnings = 0;
        }
      } else {
        let stake = resourceManager.getController("stakeController").CurrentStake;
        if (gameController.totalWinnings <= stake) {
          gameData.winningsMeter.set(gameController.totalWin);
        }
      }
      gameController.phase.step();
      gameController.doBonusesTask.leave();
    }
  }
});

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.hold()) {
    if (!autoplayManager.isAutoplayEnabled() && !gameController.justHadFreeSpins) {
      if (gameController.bigWinFinished) {
        gameController.phase.step();
        gameController.cyclingWins = true;
        timerManager.addTimeout(1500, function () {
          const respinDataAwarded = CloverRespins.respinData === undefined ? false : CloverRespins.respinData.isAwarded;
          // CoinsView.CollectSprite0.visible = false;
          // CoinsView.CollectSprite4.visible = false;

          if (
            (gameController.winGroups.length > 0 && gameController.cyclingWins && !respinDataAwarded) ||
            (gameController.coinAwards &&
              gameController.coinAwards.coins.length > 0 &&
              gameController.cyclingWins &&
              !respinDataAwarded)
          ) {
            gameController.skippingWayWins = false;
            gameController.cyclingWins = true;
            gameController.cyclingWinsIndex = 0;
            if (gameController.coinAwards.coins.length > 0) {
              //gameController.coinAwards.winAmount
              gameController.winGroups.push({
                Symbols: helper.getCollectSymbolsReelsInfo(),
                Amount: gameController.coinAwards.winAmount,
              });
            }
            gameController.cycleNextWin();
          }
        });
      }
    } else {
      gameController.phase.step();
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something

    if (gameController.isGoldenbetNowInvalid) {
      // Used only on a restore if the slot config has changed to disable golden bet.
      gameController.isGoldenbetNowInvalid = false;
      var encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
      encoreButtonLB.cancelLuckyBet();
      gameData.encoreEnabled = false;

      const stakeController = resourceManager.getController("stakeController");
      stakeController.setStakeMultiplier(1);
      const baseStake = 100;
      stakeController.requestChangeStake(baseStake, "default");

      gameData.stakeMeter.set(baseStake);
      game.changeStake(baseStake);
      stakeController.broadcastCurrentStake("default");
      gameController.currentPersistentState = gameController.getPersistentValues(gameController.getCurrentModeStake());
      gameController.updateCounterState(stakeController.getCurrentStake());
      gameController.updateCounters();
    }

    if (autoplayManager.isAutoplayEnabled()) {
      if (autoplayManager.AP.getFields()["numberOfRounds"].currentValue !== autoplayManager.AP.roundsRemaining()) {
        var timeToNext = 500;
        resourceManager.getController("autoplayController").timeToNextAutoplay = timeToNext;
        gameController.phase.step();
      }
    }
  }

  if (gameController.phase.timed(resourceManager.getController("autoplayController").timeToNextAutoplay)) {
  }

  if (gameController.phase.once()) {
    gameController.startGame();
    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {
  if (gameController.anticipating === true) {
    gameController.dimNoneWinningSymbolsBySymbolGroup(helper.getCollectSymbolsReelsInfo());
    gameController.dimPreappetureSymbols();
  }
  gameData.winningsText.show(false);
});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();

    soundManager.play("winCountUp");
  }
  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = true;
      }

      gameController.unFadeSymbols();

      gameController.stateMachine.switchState("DELAY_SHOW_WINNINGS");

      soundManager.stop("winCountUp");
      soundManager.play("winCountUpEnd");
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_ENDED", function () {
  if (gameController.phase.enter()) {
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
        gameData.mainTunePlaying = true;
      }
      gameController.stateMachine.switchState("WAITING_FOR_START");
      gameController.baseSpin = true;
      gameController.stateMachine.switchState("WAITING_FOR_START");
    });
  }
});

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

gameController.onStakeChanged = function (stake) {
  if (stake === undefined) {
    return;
  }

  if (gameController.currentStake !== stake) {
    symbolAnimator.skip();
    spineSymbolAnimator.skip();
    if (gameController.cyclingWins) {
      gameController.cyclingWins = false;
    }
    const stakes = gameData.encoreEnabled ? gameData.multipliedStakes : gameData.stakes;
    gameData.currentStakeIndex = stakes.indexOf(stake);
    gameData.winningsMeter.set(0);
    gameController.totalWinnings = 0;
    game.changeStake(stake);
    gameController.currentStake = stake;

    symbolAnimator.skip();
    symbolWinBorderAnim.skip();
    if (gameData.winningsText !== undefined) {
      gameData.winningsText.show(false);
    }
    timerManager.addTimeout(100, function () {
      gameController.slotMachine.clearDimSymbolIds();
    });
  }

  gameController.updateCounterState(stake);
  gameController.updateCounters();
};

gameController.updateCounterState = function (stake) {
  if (!gameData.slotConfig.inReplayMode) {
    gameController.currentPersistentState = gameController.getPersistentValues(stake);
    gameController.coinCollectCurrent = gameController.currentPersistentState.playerActivationCount;
    gameController.cloverSpinsCurrent = gameController.currentPersistentState.cloverCount;
  } else {
    if (gameController.cloversAdded) {
      gameController.currentPersistentState = gameController.getPersistentValues(stake);
    }
    gameController.coinCollectCurrent = gameController.currentPersistentState.playerActivationCount;
    gameController.cloverSpinsCurrent = gameController.currentPersistentState.cloverCount;
  }
};

gameController.onGameComplete = function () {
  gameController.canSkipWin = false;
  gameController.coinsCurrentlySkippable = false;
  gameController.shouldAnticipate = false;
  if (!gameController.skippingWayWins) {
    timerManager.addTimeout(100, function () {
      gameController.slotMachine.clearDimSymbolIds();
    });
  }
  let stake = resourceManager.getController("stakeController").CurrentStake;
  if (!gameController.justHadFreeSpins && gameController.totalWinnings > stake && !gameController.inFreeSpins) {
    gameController.bigWinFinished = false;
    SmallWinController.doSmallWin(gameController.totalWinnings, gameController.spinTask.data.winCapped);
  } else {
    if (!gameController.inFreeSpins) {
      gameData.winningsMeter.set(gameController.totalWinnings);
    }
    gameController.bigWinFinished = true;
    gameController.useBuyBonusThresholds = false;

    gameController.endGame();
  }
};

gameController.endGame = function () {
  if (!gameController.isPrePaid && !gameController.getIsRecovery()) {
    gameData.creditMeter.set(gameData.credit + gameController.totalWinnings);
  }

  if (gameController.inBuyABonus) {
    // keep the buy bonus stake
    const sp = gdk.getServerParser();
    const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;
    if (!inReplayOrRewatch) {
      gameController.inBuyABonus = false;
      gameController.inBuyABonusLow = false;
      gameController.inBuyABonusMed = false;
      gameController.inBuyABonusHigh = false;

      let returnStake = gameData.bonusBuyStake;

      const stakeController = resourceManager.getController("stakeController");
      // now we can have bonus buys on different stakes compared to normal
      // so 1st lets make sure the stake is valid for BASIC
      const stakeIndex = stakeController.Stakes.indexOf(returnStake);
      if (stakeIndex === -1) {
        // the bonus buy stake isnt in the BASIC stake
        // so we need to use the default
        // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
        if (!gameController.currentNonBABStake) {
          returnStake = stakeController.BaseStake;
        } else {
          returnStake = gameController.currentNonBABStake;
        }
        gameData.ignoreResetWinningsMeterOnStakeChange = true;
      }

      // const stakeController = resourceManager.getController('stakeController');
      // if (!gameController.currentNonBABStake) {
      //   gameController.currentNonBABStake = stakeController.getBaseStake('default');
      // }
      gameController.currentNonBABStake = returnStake;
      stakeController.requestChangeStake(gameController.currentNonBABStake);
      game.changeStake(gameController.currentNonBABStake);
    }
  }

  if (CloverRespins.completed) {
    CloverRespins.pulseCounter(gameController.updateCounters.bind(this));
  }

  gdk.endGame(function () {
    if (!gameData.mainTunePlaying && !gameController.inFreeSpins) {
      gameData.mainTunePlaying = true;
    }
    if (gameController.inBuyABonus) {
      gameController.totalWinnings = 0;
    }
    resourceManager.getController("autoplayController").checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");

      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }
    if (gameController.coins.length === 0) {
      gameController.checkBackgroundThemeLevels();
    }

    if (!musicManager.wasInFreeSpins) {
      musicManager.onGameEnd();
    } else {
      musicManager.wasInFreeSpins = false;
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0) {
    gameController.slamStopped = true;
    soundManager.stop("reelAnticipation");
    soundManager.stop("topReelAnticipation");

    gameController.reelsToSlam = [];
    for (let i = 0; i < gameData.reels.length; ++i) {
      gameController.reelsToSlam.push(i);

      let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
      reelVisual.coinDisplayMode = true;
    }

    gameController.slotMachine.slamReels(gameController.reelsToSlam);
  }

  let symbolHeight = resourceManager.get("slotContainer:reelContainer:reel0:symbol0").height;

  gameController.overlayDownTweens.forEach((overlay) => {
    overlay.progress(1);
    overlay.yPos = overlay.height + symbolHeight;
  });
  gameController.backingDownTweens.forEach((backing) => {
    backing.progress(1);
  });
  gameController.emptyTweenArrays();
};

gameController.emptyTweenArrays = function () {
  gameController.overlayDownTweens.forEach((anim) => {
    anim.kill();
  });
  gameController.backingDownTweens.forEach((anim) => {
    anim.kill();
  });
  gameController.overlayDownTweens = [];
  gameController.backingDownTweens = [];
};

gameController.getRandomBezierPoint = function (startPoint, endPoint, distanceScaler, direction) {
  // pass in undefined for unneeded parameters and it will pick a hopefully sensible default value
  // distanceScaler - (0.0 - 1.0) - Distance to move the bezier point away from the line - 0.0 = no movement, 1.0 = full line distance
  if (distanceScaler === undefined) {
    distanceScaler = 0.25; // Default to 25% of the line distance
  } else {
    // Clamp the distance scaler to 0.0 - 1.0
    distanceScaler = Math.min(1.0, Math.max(0.0, distanceScaler));
  }
  // direction - (0 or 1) - direction to move the bezier point - 0 = right, 1 = left
  // from the perspective of the line direction, stood at start point looking at end point
  if (direction !== 0 && direction !== 1) {
    direction = Math.floor(Math.random() * 2);
  }

  const midPoint = {
    x: (startPoint.x + endPoint.x) / 2,
    y: (startPoint.y + endPoint.y) / 2,
  };
  const directionVector = {
    x: endPoint.x - startPoint.x,
    y: endPoint.y - startPoint.y,
  };
  const mainLineMagnitude = Math.sqrt(directionVector.x ** 2 + directionVector.y ** 2);
  const distance = mainLineMagnitude * distanceScaler;
  const perpendicularVector = { x: -directionVector.y, y: directionVector.x };
  const perpendicularMagnitude = Math.sqrt(perpendicularVector.x ** 2 + perpendicularVector.y ** 2);
  perpendicularVector.x /= perpendicularMagnitude;
  perpendicularVector.y /= perpendicularMagnitude;
  const scaledPerpendicularVector = {
    x: perpendicularVector.x * distance,
    y: perpendicularVector.y * distance,
  };

  let xPos;
  let yPos;

  if (direction === 0) {
    xPos = midPoint.x + scaledPerpendicularVector.x;
    yPos = midPoint.y + scaledPerpendicularVector.y;
  } else {
    xPos = midPoint.x - scaledPerpendicularVector.x;
    yPos = midPoint.y - scaledPerpendicularVector.y;
  }

  const bezierPoint = { x: xPos, y: yPos };
  return bezierPoint;
};

gameController.calculateMagnitude = function (startPos, endPos) {
  const deltaX = endPos.x - startPos.x;
  const deltaY = endPos.y - startPos.y;
  return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
};

gameController.calculateQuadraticBezierPosition = function (t, P0, P1, P2) {
  let x = Math.pow(1 - t, 2) * P0.x + 2 * (1 - t) * t * P1.x + Math.pow(t, 2) * P2.x;
  let y = Math.pow(1 - t, 2) * P0.y + 2 * (1 - t) * t * P1.y + Math.pow(t, 2) * P2.y;
  return { x: x, y: y };
};

gameController.doPayWins = function (winTask) {
  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();

  gameController.totalWin = winTask.data.winAmount;

  let winlines = winTask.data.payWaysLeft.payWaysWins;

  gameController.symbolsToAnimate = [];

  gameController.winlinesWins = [];
  gameController.winGroups = [];
  gameController.winGroupSymbolIds = [];

  for (let i = 0; i < winlines.length; i++) {
    const winline = winlines[i];
    gameController.winlinesWins.push(winline.totalWin);
    const winGroupSymbols = [];
    const winGroupWin = winline.totalWin;
    const winGroupSymbolId = winline.symbol;

    for (let j = 0; j < winline.coords.length; j++) {
      const coord = winline.coords[j];

      const symbolID = gameController.symbolMap.find(
        (element) => element.cell.reel === coord.reel && element.cell.row === coord.row
      ).symbolId;

      winGroupSymbols.push({
        symbolId: symbolID,
        cell: coord,
      });

      gameController.symbolsToAnimate.push({
        symbolId: symbolID,
        cell: coord,
      });
    }
    gameController.winGroupSymbolIds.push(winGroupSymbolId);
    gameController.winGroups.push({
      Symbols: winGroupSymbols,
      Amount: winGroupWin,
    });
  }

  let stake = resourceManager.getController("stakeController").CurrentStake;

  // gameController.checkBackgroundThemeLevels();
  if (gameController.totalWin > stake) {
    gameController.fadeSound([gameData.themeTuneId, gameData.freespinsThemeTuneId], 0.5, 500, false);
  }

  gameController.lastPayWinsData = winTask.data;

  timerManager.addTimeout(250, function () {
    symbolAnimator.skip();
    spineSymbolAnimator.skip();
    gameController.canSkipWin = true;
    gameController.cyclingWinsIndex = 0;
    gameController.cyclingWins = false;
    gameController.cycleWin();
  });
};

gameController.checkBackgroundThemeLevels = function () {
  let stake = resourceManager.getController("stakeController").CurrentStake;
  let levelUpStake = gameController.getCurrentMode() === "LuckyBet" ? stake / 1.5 : stake;
  if (gameController.inFreeSpins) {
    if (gameController.totalWinnings >= 50 * levelUpStake) {
      musicManager.freeSpinsNextLevel(2);
    } else if (gameController.totalWinnings >= 20 * levelUpStake) {
      musicManager.freeSpinsNextLevel(1);
    }
  } else {
    if (musicManager.checkThemeLevel() === -1) {
      musicManager.baseGameNextLevel(2);
      musicManager.setStepDownTimer();
    } else if (musicManager.checkThemeLevel() === 1) {
      if (gameController.totalWinnings >= 10 * levelUpStake) {
        musicManager.baseGameNextLevel(2);
      } else if (gameController.totalWinnings >= 5 * levelUpStake && gameController.totalWinnings < 10 * levelUpStake) {
        musicManager.baseGameNextLevel(1);
      }
    } else if (musicManager.checkThemeLevel() === 2 || musicManager.checkThemeLevel() === 3) {
      if (gameController.totalWinnings > stake) {
        musicManager.baseGameNextLevel(2);
        gameController.themeResetCount = 0;
      } else {
        gameController.themeResetCount++;
      }
      if (gameController.themeResetCount === 15) {
        musicManager.baseGameNextLevel(0);
        gameController.themeResetCount = 0;
      }
    }
  }
};

gameController.doBonuses = function (bonusTask) {
  gameController.doBonusesTask = bonusTask;
  gameController.doBonusesTask.join();

  gameController.canSkipWin = false;
  gameController.coinsCurrentlySkippable = false;
  gameController.slotMachine.clearDimSymbolIds();
  gameController.winlineAnimator.clearWinlines();

  //Switch Reel Visual to coin display mode.
  for (let i = 0; i < 5; i++) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.coinDisplayMode = true;
  }

  if (gameController.winningLines) {
    timerManager.addTimeout(1000, function () {
      gameController.stateMachine.switchState("WAITING_FOR_BONUSES");
    });
  } else {
    gameController.stateMachine.switchState("WAITING_FOR_BONUSES");
  }
};

gameController.cycleWin = function () {
  if (gameController.winGroups.length === 0 || gameController.skippingWayWins) {
    symbolAnimator.finishedCallback = undefined;
    return;
  }
  const completeCallBack =
    gameController.cyclingWins | !gameController.cyclingWins &&
    gameController.cyclingWinsIndex < gameController.winGroups.length - 1
      ? gameController.cycleWin.bind(this)
      : gameController.winlinePreAnimsDone.bind(this);

  const delay =
    gameController.cyclingWins | !gameController.cyclingWins &&
    gameController.cyclingWinsIndex < gameController.winGroups.length - 1
      ? 750
      : 250;

  if (gameController.cyclingWins) {
    // Play the actual win animation.
    symbolAnimator.animate(
      gameController.winGroups[gameController.cyclingWinsIndex].Symbols,
      gameController.cycleNextWin.bind(this),
      750
    );
    gameController.slotMachine.clearDimSymbolIds();
    gameController.dimNoneWinningSymbolsBySymbolGroup(
      gameController.winGroups[gameController.cyclingWinsIndex].Symbols
    );
  } else {
    // Play the scale up animation.
    if (gameController.checkWinIsAboveThreshold()) {
      gameController.playWinningSound(gameController.winGroupSymbolIds[gameController.cyclingWinsIndex]);
    } else {
      soundManager.play("winLine");
    }
    symbolAnimator.animate(gameController.winGroups[gameController.cyclingWinsIndex].Symbols, completeCallBack, delay);
    gameController.slotMachine.clearDimSymbolIds();
    gameController.dimNoneWinningSymbolsBySymbolGroup(
      gameController.winGroups[gameController.cyclingWinsIndex].Symbols
    );
  }
  let symbolPos;
  let symbolToUse;

  for (let index = 0; index < gameController.winGroups[gameController.cyclingWinsIndex].Symbols.length; index++) {
    const symbol = gameController.winGroups[gameController.cyclingWinsIndex].Symbols[index];
    if (symbol.cell.reel === 2) {
      const symbolToPos = resourceManager.get(
        `slotContainer:reelContainer:reel${symbol.cell.reel}:symbol${symbol.cell.row}`
      );
      symbolPos = this.position = helper.getLocalFromGlobalPosition(symbolToPos, gameData.winningsText);

      symbolToUse = symbol;
    }
  }
  gameData.winningsText.visible = true;
  gameData.winningsText.setText(
    gameController.winGroups[gameController.cyclingWinsIndex].Amount,
    symbolPos,
    symbolToUse
  );
  gameData.winningsText.cycleAnimate();
  gameData.winningsText.show(true);
  gameController.cyclingWinsIndex++;
  if (gameController.cyclingWins && gameController.cyclingWinsIndex >= gameController.winGroups.length) {
    gameController.cyclingWinsIndex = 0;
  }
};

gameController.checkWinIsAboveThreshold = function () {
  let stake = resourceManager.getController("stakeController").CurrentStake;
  return gameController.totalWinnings > stake;
};

gameController.playWinningSound = function (winningId) {
  const soundMap = {
    0: "symbolLow",
    1: "symbolLow",
    2: "symbolLow",
    3: "symbolLow",
    4: "symbolLow",

    5: "symbolMedium",
    6: "symbolGuinness",
    7: "symbolFlamingo",

    8: "symbolMushroom",
    9: "symbolLepF",
    10: "symbolLogo",
  };

  const sound = soundMap[winningId];

  if (sound) {
    soundManager.play(sound);
  }
};

gameController.getRandomIndex = function () {
  return Math.floor(Math.random() * 2) + 1;
};

gameController.cycleNextWin = function () {
  if (gameController.cyclingWins) {
    gameController.slotMachine.clearDimSymbolIds();
    gameController.waitingForNextWinAnimation = true;
  }
  timerManager.addTimeout(250, function () {
    if (
      gameController.cyclingWins &&
      // !gameController.symbolAnimating &&
      // !gameController.animating &&
      gameController.winGroups.length > 0
    ) {
      symbolAnimator.skip();
      gameController.waitingForNextWinAnimation = false;
      gameController.cycleWin();
    } else {
      gameController.skippingWayWins = true;
    }
  });
};

gameController.stopCyclingWins = function () {
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.lastPayWinsData = undefined;
  gameController.winlineAnimator.skipAnimation();
  gameController.winlineAnimator.clearWinlines();
  gameController.cyclingWinsIndex = 0;
  gameData.winningsText.visible = false;
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  // dim none winning symbols
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let coords = winningLine.coords;
    for (let j = 0; j < coords.length; ++j) {
      let cell = coords[j];
      let includedAlready = false;
      for (let p = 0; p < winningPositions.length; ++p) {
        const pos = winningPositions[p];
        if ((cell.reel === pos.reel) & (cell.row === pos.row)) {
          includedAlready = true;
          break;
        }
      }
      if (!includedAlready) {
        winningPositions.push({ reel: cell.reel, row: cell.row });
      }
    }
  }
  // This is soooo bad! So inefficient!
  let symbolsToDim = [];
  for (let reel = 0; reel < gameData.reels.length; ++reel) {
    const reelHeight = (reel === 0) | (reel === 4) ? 3 : gameData.reels[reel].appertureHeight;
    for (let row = 0; row < reelHeight; ++row) {
      let isAWinningPosition = false;

      for (let p = 0; p < winningPositions.length; ++p) {
        const pos = winningPositions[p];
        if ((reel === pos.reel) & (row === pos.row)) {
          isAWinningPosition = true;
          break;
        }
      }
      if (!isAWinningPosition) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.dimNoneWinningSymbolsBySymbolGroup = function (winningSymbols) {
  gameController.slotMachine.dimAllSymbols(true, 0.1);
  winningSymbols.forEach(({ cell: { reel, row } }) => gameController.slotMachine.dimSymbol(reel, row, false, 0));
};

gameController.dimPreappetureSymbols = function () {
  for (let r = 0; r < gameData.reels.length; r++) {
    const reel = gameData.reels[r];
    for (let row = r === 0 || r === 4 ? 3 : reel.appertureHeight; row < reel.appertureHeight + 4; row++) {
      reel.dimSymbol(row, true, 0.1);
    }
  }
};

gameController.winlinePreAnimsDone = function () {
  gameData.winningsText.show(false);
  gameController.slotMachine.clearDimSymbolIds();
  if (gameController.coinAwards && gameController.coinAwards.winAmount > 0 && !gameController.inFreeSpins) {
    gameData.winningsMeter.set(gameController.winTask.data.winAmount);
  }
  let stake = resourceManager.getController("stakeController").CurrentStake;
  if (gameController.winTask.data.winAmount > stake) {
    gameController.dimNoneWinningSymbols(gameController.winTask.data.payWaysLeft.payWaysWins);
    gameController.playHighlightSounds();
    symbolWinBorderAnim.playAnimation(gameController.symbolsToAnimate, gameController.winlineAnimsDone.bind(this));
  } else {
    gameController.winlineAnimsDone();
  }
};

gameController.playHighlightSounds = async function () {
  soundManager.play("winLine");
  await gameController.delay(750);
  soundManager.play("winLine");
};

gameController.doBigWin = function () {
  gameController.lastPayWinsData = gameController.winTask.data;
  let winnings = gameController.lastPayWinsData.winAmount;

  let isBigWin = gameController.bigWin.willTriggerBigWin(winnings, gameController.globalHelperGetBaseStake());

  if (isBigWin && !gameController.inFreeSpins) {
    gameController.bigWin.start(
      winnings,
      gameController.winTask.data.isCapped,
      null,
      null,
      function () {
        gameController.bigWinDone();
      },
      "basegame"
    );
  } else {
    gameController.bigWinDone();
  }
};

gameController.bigWinDone = function () {
  if (gameController.inFreeSpins) {
    gameData.winningsMeter.countUp(gameController.totalWinnings, 1500);
  } else {
    resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").exitFreeSpins();
    gsap.to(gameData.winningsMeter.scale, {
      duration: 0.3,
      ease: "power1.inOut",
      x: 1.25,
      y: 1.25,
      repeat: 1,
      yoyo: true,
    });
    gameData.winningsMeter.set(gameController.totalWinnings);
    soundManager.play("addToCredit");
  }
  gameController.useBuyBonusThresholds = false;
  gameController.bigWinFinished = true;
  if (!this.inFreeSpins) {
    gameController.endGame();
  } else {
    SmallWinController.freeSpinsEndCallback();
  }
};

gameController.winlineAnimsDone = function () {
  gameController.canSkipWin = false;
  gameController.coinsCurrentlySkippable = false;

  let stake = resourceManager.getController("stakeController").CurrentStake;
  let creditSound = gameController.inFreeSpins ? "addToCreditFS" : "addToCredit";
  soundManager.play(creditSound);

  if (gameController.inFreeSpins) {
    if (gameController.hasCoinWin) {
      let coinWinAmout = gameController.coinAwardsBeforeGoldenSpins.winAmount;
      if (GoldenSpins.goldenSpins !== undefined && GoldenSpins.goldenSpins.winAmount > 0) {
        coinWinAmout += GoldenSpins.goldenSpins.winAmount;
      }
      gameData.winningsMeter.set(gameController.totalWinnings - coinWinAmout);
    } else {
      gameData.winningsMeter.set(gameController.totalWinnings);
    }
  }

  if (gameController.coinAwards && gameController.coinAwards.winAmount > 0 && !gameController.inFreeSpins) {
    gameData.winningsMeter.set(gameController.winTask.data.winAmount);
  }

  if (gameController.winTask.data.winAmount > stake) {
    gameController.fadeSound([gameData.themeTuneId, gameData.freespinsThemeTuneId], 1, 250, true);
  }
  if (gameController.skippingWayWins) {
    //gameController.dimAllNoneWinningSymbolsBySymbolGroup();
    timerManager.addTimeout(500, function () {
      gameController.winlineAnimator.clearWinlines();
      gameController.winTask.leave();
      gameController.winTask = undefined;
    });
  } else {
    gameController.winTask.leave();
    gameController.winTask = undefined;
  }
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skipWin = function () {
  CoinCollectionController.skipWins();
  if (gameController.canSkipWin && !gameController.coinsCurrentlySkippable && !gameController.cyclingWins) {
    gameController.slotMachine.clearDimSymbolIds();
    gameData.winningsText.show(false);
    symbolWinBorderAnim.skip();
    symbolAnimator.skip();
    spineSymbolAnimator.skip();
    gameController.skippingWayWins = true;
    gameController.winlineAnimsDone();
  } else if (gameController.canSkipWin && gameController.coinsCurrentlySkippable) {
    if (gameController.prizePotAnimationsComplete === false) {
      //We're doing the prize pot animations.
      //} else if (gameController.cloverRespinsComplete === false) {
      //We're  doing clover respins right now.
    } else if (gameController.cashCoinsAnimationsComplete === false) {
      //We're doing the coin animations.
      CoinsView.canSkipCoins = true;
    }
  }
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;

  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = function () {
  resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").enterFreeSpins();

  gameController.inFreeSpins = true;

  musicManager.onFreespinsStart();

  gameController.previousResult = [];

  if (!gameController.inBuyABonus) {
    gameData.winningsMeter.set(gameController.totalWinnings);
    if (gameController.totalWinnings > resourceManager.getController("stakeController").CurrentStake) {
      gsap.to(gameData.winningsMeter.scale, {
        duration: 0.3,
        ease: "power1.inOut",
        x: 1.25,
        y: 1.25,
        repeat: 1,
        yoyo: true,
      });
    }
    gameController.amountWonInBaseGame = gameController.totalWinnings;
  } else {
    gameController.inBuyABonusFirstSpin = true;
  }
  autoplayManager.stopAutoplay();
};

gameController.onFreespinsEnd = function () {
  gameController.removeSlidingOverlays();
  gameData.winningsMeter.set(gameController.totalWinnings);
  soundManager.play("addToCreditFS");
  resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").exitFreeSpins();

  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
  gameController.freeSpinsTransitionOut = false;
  gameController.slotMachine.clearDimSymbolIds();
  gameController.clearLockedCoins();
  resourceManager.getController("inputOverlord").setState("enabled");
};

gameController.onFeatureStart = function (task) {
  //this._featureStartTask = task;
  //this._featureStartTask.join();
};

/**
 * Gets the current stake (if in buyBonus this will be overall stake)
 * @returns Stake
 */
gameController.globalHelperGetStake = function () {
  const stakeController = resourceManager.getController("stakeController");
  let stake;

  if (gameController.inBuyABonusHigh) {
    stake = stakeController.getCurrentStake("BONUS_BUY_HIGH") * gameController.buyBonusCostFreeSpinsHigh;
  } else if (gameController.inBuyABonusMed) {
    stake = stakeController.getCurrentStake("BONUS_BUY_MED") * gameController.buyBonusCostFreeSpinsMed;
  } else if (gameController.inBuyABonusLow) {
    stake = stakeController.getCurrentStake("BONUS_BUY_LOW") * gameController.buyBonusCostFreeSpinsLow;
  } else if (gameData.currentStakeIndex === -1) {
    stake = gameController.currentStake;
  } else {
    stake = gameData.stakes[gameData.currentStakeIndex];
  }

  return stake;
};

gameController.globalHelperGetCurrentModeStake = function (ignoreGoldenBetMultiplier = false) {
  let stake = 0;

  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    if (gameData.encoreEnabled && !ignoreGoldenBetMultiplier) {
      stake = stakeController.getBaseStake() * 1.5;
    } else {
      stake = stakeController.getBaseStake();
    }

    if (gameController.inBuyABonus) {
      if (gameController.inBuyABonusLow) {
        stake = stakeController.getCurrentStake("BONUS_BUY_LOW");
      }
      if (gameController.inBuyABonusMed) {
        stake = stakeController.getCurrentStake("BONUS_BUY_MED");
      }
      if (gameController.inBuyABonusHigh) {
        stake = stakeController.getCurrentStake("BONUS_BUY_HIGH");
      }
    }
  }
  return stake;
};

gameController.globalHelperGetBaseStake = function () {
  const stakeController = resourceManager.getController("stakeController");
  return stakeController.getBaseStake();
};

gameController.recoverGame = function (task) {
  // Get stake controller and recovery stake data
  let stakeController = resourceManager.getController("stakeController");
  let recoveryFullStake = gameData.recoveryStake;
  // Recovery game with encore
  if (task.data.metaData === "encore") {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
    encoreButtonLB.setRecovery();
  }
  gameController.SeedUIGenerator(task.data.UIRandomSeed);

  gameController.inRecovery = true;
  let luckyBetEnabled = gameData.encoreEnabled;

  if (task.data.metaData === "buyABonusLow" && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, "BONUS_BUY_LOW");
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.inBuyABonusLow = true;
    gameController.initNewSpin(true);
  } else if (task.data.metaData === "buyABonusMed" && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, "BONUS_BUY_MED");
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.inBuyABonusMed = true;
    gameController.initNewSpin(true);
  } else if (task.data.metaData === "buyABonusHigh" && task.data.metaValue) {
    gameData.bonusBuyStake = recoveryFullStake;
    stakeController.requestChangeStake(recoveryFullStake, "BONUS_BUY_HIGH");
    gameData.stakeMeter.set(recoveryFullStake);
    gameController.inBuyABonus = true;
    gameController.inBuyABonusHigh = true;
    gameController.initNewSpin(true);
  } else {
    musicManager.onGameStart();
    gameController.initNewSpin();

    // Update stake

    let baseStake = gameController.inBuyABonus ? task.data.bpl : stakeController.BaseStake;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1));
    stakeController.broadcastCurrentStake();
  }

  if (luckyBetEnabled) {
    var luckyBetButton = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
    luckyBetButton.setRecovery();
  }
  gameController.currentPersistentState = gameController.getPersistentValues(
    gameController.globalHelperGetCurrentModeStake()
  );
  gameController.updateCounterState(gameController.globalHelperGetCurrentModeStake());
  gameController.updateCounters();
};

gameController.getBonusMode = function (mode) {
  if (mode === "buyABonusLow") {
    mode = "BONUS_BUY_LOW";
  } else if (mode === "buyABonusMed") {
    mode = "BONUS_BUY_MED";
  } else if (mode === "buyABonusHigh") {
    mode = "BONUS_BUY_HIGH";
  }

  return mode;
};

gameController.setBonusBuy = function (data) {
  if (data === "buyABonusLow") {
    gameController.inBuyABonusLow = true;
  }
  if (data === "buyABonusMed") {
    gameController.inBuyABonusMed = true;
  }
  if (data === "buyABonusHigh") {
    gameController.inBuyABonusHigh = true;
  }
};

gameController.restoreCounters = function (initialPlayerState) {
  let data = JSON.parse(initialPlayerState.data.state);
  let stake = gameController.globalHelperGetCurrentModeStake();
  let mode = gameController.getCurrentMode();
  if (mode === "BonusBuyLow" || mode === "BonusBuyMedium" || mode === "BonusBuyHigh") {
    if (gameData.encoreEnabled) {
      mode = "LuckyBet";
    } else {
      mode = "Basic";
    }
  }
  if (mode === "LuckyBet") {
    stake = stake / 1.5;
  }
  if (data.CloverProgress[mode] && data.CloverProgress[mode][stake] !== undefined) {
    gameController.cloverSpinsCurrent = data.CloverProgress[mode][stake].RespinsCount;
    gameController.coinCollectCurrent = data.CloverProgress[mode][stake].ActivationCount;
  } else {
    gameController.cloverSpinsCurrent = gameController.defaultCloverCount;
    gameController.coinCollectCurrent = gameController.defaultCoinCount;
  }
  gameController.updateCounters();
};

gameController.onAbortGame = function () {
  gameController.slotMachine.abortSpin();
  for (let i = 0; i < 5; i++) {
    let reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.coinDisplayMode = true;
  }
  Loader.setStartingSymbols();
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cyclingWinsIndex = 0;
  if (gameController.coinAwards && gameController.coinAwards.coins.length > 0) {
    //gameController.coinAwards.winAmount
    gameController.winGroups.push({
      Symbols: helper.getCollectSymbolsReelsInfo(),
      Amount: gameController.coinAwards.winAmount,
    });
  }
  if (
    gameController.coinAwardsBeforeGoldenSpins &&
    !gameController.coinAwardsAfterGoldenSpins &&
    gameController.coinAwardsBeforeGoldenSpins.coins.length > 0
  ) {
    gameController.winGroups.push({
      Symbols: helper.getCollectSymbolsReelsInfo(),
      Amount: gameController.coinAwardsBeforeGoldenSpins.winAmount,
    });
  } else if (gameController.coinAwardsAfterGoldenSpins && gameController.coinAwardsAfterGoldenSpins.coins.length > 0) {
    gameController.winGroups.push({
      Symbols: helper.getCollectSymbolsReelsInfo(),
      Amount: gameController.coinAwardsAfterGoldenSpins.winAmount,
    });
  }
  if (!gameController.justHadFreeSpins) {
    gameController.cycleWin();
  }
};

gameController.onOrientationChange = function () {
  // REPOSITION COIN COUNTER METER MASK
  if (gameController.gameInitialised) {
    if (gameController.inFreeSpins) {
      gameController.coinCollectGreenFill.visible = false;
      gameController.coinCollectGoldFill.visible = false;
    } else {
      const mode = gameController.getCurrentMode();
      let currentCoinCollectFill;
      if (mode === "LuckyBet") {
        gameController.coinCollectGreenFill.visible = false;
        currentCoinCollectFill = gameController.coinCollectGoldFill;
      } else {
        gameController.coinCollectGoldFill.visible = false;
        currentCoinCollectFill = gameController.coinCollectGreenFill;
      }

      currentCoinCollectFill.visible = true;
      const currentLayout = layoutController.getCurrentLayout();
      const greenFillOrientationInfo = currentCoinCollectFill.parent.Props[currentLayout];
      const greenFillLeftEdge = greenFillOrientationInfo.position.x;
      const greenFillTopEdge = greenFillOrientationInfo.position.y;

      gameController.coinCollectGreenFillMask.x = greenFillLeftEdge;
      gameController.coinCollectGreenFillMask.y = greenFillTopEdge;

      currentCoinCollectFill.mask = gameController.coinCollectGreenFillMask;
    }
    SmartTweens.recalculate();
  }

  timerManager.delayAsync(0, undefined, () => {
    gameController.updateCounters(true);
  });

  gameController.overlayDownTweens.forEach((overlay) => {
    overlay.progress(1);
  });
  gameController.backingDownTweens.forEach((backing) => {
    backing.progress(1);
  });
  gameController.emptyTweenArrays();

  CoinsView.orientationChange();
  symbolAnimator.orientationChange();
  spineSymbolAnimator.orientationChange();
  PrizePots.orientationChange();
  GoldenSpins.orientationChange();
  if (gameData.winningsText !== undefined) {
    timerManager.addTimer(20, () => {
      gameData.winningsText.resetPosition();
    });
  }

  timerManager.addTimer(5, () => {
    let cloverCountContainer = resourceManager.get("postReels:rapidRespinsContainer");
    let coinCountMeter = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeter");
    //let coinCountText = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont");
    if (gameController.inFreeSpins && !gameController.freeSpinsTransitionOut) {
      cloverCountContainer.visible = false;
      coinCountMeter.visible = false;
      //coinCountText.visible = false;
    } else {
      cloverCountContainer.visible = true;
      coinCountMeter.visible = true;
      //coinCountText.visible = true;
    }
  });
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Game Aborted") {
      let reel1Size = resourceManager.get("slotContainer:reelContainer:reel1").startingAppertureHeight;
      let reel2Size = resourceManager.get("slotContainer:reelContainer:reel2").startingAppertureHeight;
      let reel3Size = resourceManager.get("slotContainer:reelContainer:reel3").startingAppertureHeight;

      gameController.desktopWinWaysCounter.setText(3 * reel1Size * reel2Size * reel3Size * 3);
      //gameController.mobileWinWaysCounter.setText(3 * reel1Size * reel2Size * reel3Size * 3);
    }
    if (event.reason === "Platform Paused") {
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (event.data === "Platform Popup Close" && !gameController.platformPaused) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};

Reflex.addToUpdate(gameController.update);

messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
//messageBus.subscribe("spinner:SpinEventDead", gameController.stopReelAnticipation);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.doPayWins);
messageBus.subscribe("game:coinResultEvent", gameController.doBonuses);
messageBus.subscribe("game:restoreCountersEvent", gameController.restoreCounters);
messageBus.subscribe("game:FeatureAnnounceEvent", gameController.onFeatureStart);
messageBus.subscribe("spinner:FreeSpinsStartEvent", gameController.onFreespinsStart);
messageBus.subscribe("spinner:FreeSpinsEndEventDead", gameController.onFreespinsEnd);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe("platform:ReplayComplete", gameController.replayComplete);
messageBus.subscribe("game:modal", gameController.onModal);
messageBus.subscribe("spinner:GameConfigEvent", gameController.onLayoutComplete);

Reflex.registerEventHandler("orientationChange", gameController.onOrientationChange);
